export default __webpack_public_path__ + "static/media/syncing-error.07ce337f.svg";